module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-bb-bg-2-40759143df66f82140fc06c9d31763b2.png";